import { BotControlSet, BotControlSetResponse } from './types'

export const mapBotControlSetForRequest = (raw: BotControlSet): unknown => ({
  bot_control_set_id: raw.id,
  conclusion: raw.conclusion,
  language_code: raw.languageCode,
  text: raw.text,
})

export const mapBotControlSetForResponse = (raw: any): BotControlSet => ({
  id: raw.data.id,
  conclusion: raw.data.conclusion,
  currentVersion: raw.data.current_version,
  languageCode: raw.data.language_code,
  text: raw.data.text,
  userId: raw.data.user_id,
})

export const mapBotControlSetForList = (raw: any): BotControlSetResponse => ({
  list: raw.data_list.map((item: unknown) =>
    mapBotControlSetForResponse({ data: item })
  ),
  dataCount: raw.data_count,
  pageCount: raw.page_count,
  message: raw.message,
  success: raw.success,
})
